import React from 'react';

import { useAskAISidepanel } from './useAskAISidepanel';

interface AskAISidepanelProps {
  askAiSidepanel: {
    isVisible: boolean;
    width: string | number;
  };
}

/**
 * Higher-Order Component that injects Ask AI sidepanel props to the wrapped component
 * @param WrappedComponent - The component to wrap
 * @returns Enhanced component with Ask AI sidepanel props
 */
export const withAskAiSidepanel = <P extends object>(
  WrappedComponent: React.ComponentType<P & AskAISidepanelProps>,
) => {
  const WithAskAiSidepanel = (props: P) => {
    const askAiSidepanel = useAskAISidepanel();

    return <WrappedComponent {...props} askAiSidepanel={askAiSidepanel} />;
  };

  return WithAskAiSidepanel;
};
